// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1792013454576
      var cssReload = require("/home/ubuntu/zoetis/apps/my-consult/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  